import { ComponentWithSelect } from './ComponentWithSelect.main';

export { ComponentWithSelect };
